import type { VirtualSiteGroupDto } from "../../types/VirtualSiteGroupDto";
import type { VirtualSiteGroupEntity } from "../../types/VirtualSiteGroupEntity";

export const VirtualSiteGroupEntityToDto = ({ cardTypeMappings, ...rest }: Readonly<VirtualSiteGroupEntity>): VirtualSiteGroupDto => {
    return {
        ...rest,
        cardTypeMappings: cardTypeMappings?.map((mapping) => ({
            id: mapping.id,
            applicationProfileListId: mapping.applicationProfileListId,
            cardTypeName: mapping.cardTypeName,
        })),
    };
};
